// This file is automatically updated during the build process
// Do not edit manually

export const SDK_VERSION = "1.0.1-beta.1";
export const SDK_NAME = "@prexo/ai-chat-sdk";
